import React from 'react';
import BottomNav from '../components/BottomNav';
import MembershipCard from '../components/MembershipCard';
import ServiceCard from '../components/ServiceCard';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();

  // Check if user has Gold or higher membership
  const isGoldOrHigher = user && ['Gold', 'Platinum', 'LGC', 'Privé', 'Admin'].includes(user.membershipLevel);

  const services = [
    { title: 'London Gold Club', link: 'https://londongoldclub.com/', external: true },
    { title: 'IBV Gift of Gold', link: 'https://ibvgiftofgold.com/', external: true },
    { title: 'Future Leaders Club-AI Tutor', link: 'https://tutor.ainexgensa.co.za', external: true },
    { title: 'IBV Insurance & Family Fiduciary', link: '/insurance-wealth-protection' },
    { title: 'VIP Luxury Chauffeur Service', link: '/concierge' },
    { title: 'London VIP Protect', link: '/concierge' },
    { title: 'IBV Luxury Travel Concierge', link: '/travel' },
    { title: 'Privé Social Events, Music, Fine Wines & Culinary Experience', link: '/news' },
    { title: 'Privé Business Leadership Events', link: '/prive-business-leadership' },
    { title: 'Finance, Wealth & Global Advisory', link: '/wealth-advisory' },
    { title: 'IBV Privé Private Wealth Club', link: '/prive-lounge'},
    { title: 'IBV Privé Lounge & Bakery Online', link: '/prive-wealth-club'  }
  ];

  const locations = ['London', 'Dubai', 'South Africa'];

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="top-logo" style={{textAlign: 'center', marginBottom: '1rem'}}>
          <img src="/images/IBVlogo.png" alt="IBV Wealth Club" style={{maxWidth: '150px', height: 'auto'}} />
        </div>

        <div className="location-nav">
          {locations.map((location) => (
            <button key={location} className="location-btn">{location}</button>
          ))}
        </div>

        <div className="dashboard-heading">
          <div className="underline"></div>
        </div>

        <MembershipCard />

        <div className="service-grid">
          {services.map((service, index) => (
            <ServiceCard 
              key={index} 
              title={service.title} 
              link={service.link}
              locked={service.locked}
              requiredTier={service.requiredTier}
              external={service.external}
              description={service.description}
            />
          ))}
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default Dashboard;
